import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { ExerciseType, Subscription, UserEpa } from '../store.types';
import { Route } from '@react-navigation/native';

export interface GlobalStateModel {
  isPatientDemo: boolean;
  isTherapistDemo: boolean;
  lastVisitedPage: Route<keyof TherapistStackParamList> | undefined;
  loading: boolean;
  isAuthenticated: boolean;
  appType: string;
  copyTextsetExerciseTypes: ExerciseType[];
  copySentencesetExerciseTypes: ExerciseType[];
  copyWordsetExerciseTypes: ExerciseType[];
  copyAudioSpeedSettings: string;
  autoPlayNextQuestion: boolean;
  maxExerciseItems: number;
  stayLoggedIn: boolean;
  subscriptions: Subscription[];
  permissions: Subscription;
  showConsentModal: {
    show: boolean;
    buttonText: string;
    documents: { uri: string }[];
    document?: {
      uri: string;
    };
  };
  showAppNeedToBeUpdatedModal: boolean;
  showCriticalAppUpdateModal: boolean;
  seenUpdates: object;
  latestUpdates: string;
  userConsents: UserConsent[];
  userEpa: UserEpa;
  showLoadingSpinner: boolean;
}

export interface UserConsent {
  _id: string;
  name: string;
  givenConsent: boolean;
  consentText: string;
  consentInfoLinkAddress: string;
  consentInfoLinkText: string;
  revocable: boolean;
}

const globalState = {
  isPatientDemo: false,
  isTherapistDemo: false,
  loading: false,
  isAuthenticated: false,
  appType: 'patient',
  copyTextsetExerciseTypes: [],
  copySentencesetExerciseTypes: [],
  copyWordsetExerciseTypes: [],
  copyAudioSpeedSettings: '',
  autoPlayNextQuestion: false,
  maxExerciseItems: 0,
  stayLoggedIn: false,
  userConsents: [],
  subscriptions: [],
  permissions: {},
  showConsentModal: { show: false, buttonText: '', documents: [] },
  showAppNeedToBeUpdatedModal: false,
  showCriticalAppUpdateModal: false,
  seenUpdates: {},
  latestUpdates: '',
  userEpa: {},
  showLoadingSpinner: false,
};

export default globalState;
